
const digest = '81ae6291b377b5d8bb05da371f379c37319528400b423ffb406015591d64209b';
const classes = {"wrapper":"_wrapper_ypx2f_1","textBold":"_textBold_ypx2f_7","controls":"_controls_ypx2f_10","iconWrapper":"_iconWrapper_ypx2f_17"};
const css = `._wrapper_ypx2f_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
._wrapper_ypx2f_1 ._textBold_ypx2f_7 {
  font-weight: 500;
}
._wrapper_ypx2f_1 ._controls_ypx2f_10 {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
  justify-content: space-between;
}
._wrapper_ypx2f_1 ._iconWrapper_ypx2f_17 {
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  